import React from 'react';

import { Container } from './styles';

const Simple: React.FC = ({ children }) => (
  <Container>
    {children}
  </Container>
);

export default Simple;
